"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdGrecaptchaDownloadService = void 0;
const rxjs_1 = require("rxjs");
/**
 * Servizio platform per il download delle api google
 * Viene creato una subject di tipo Replay in modo che dopo il "true"
 * vengano avvisati anche i futuri sottoscrittori
 *
 * INTERNAL SERVICE DONT EXPORT
 */
class TpdGrecaptchaDownloadService {
    constructor(tpdLoggerService) {
        this.tpdLoggerService = tpdLoggerService;
        this._isReady = false;
        this._isWaiting = false;
        this.ID_LOGGER = "TpdGrecaptchaDownloadService";
        this.subscription = new rxjs_1.ReplaySubject();
    }
    /**
     * Metodo per la richiesta delle api.js
     * Se già scaricata, non effettua il nuovo download ma genera il next automatico precedente
     * grazie al ReplaySubject
     * @returns Observable<boolean>
     */
    grecaptchaWaitingDownload() {
        this.tpdLoggerService.printLog(this.ID_LOGGER, `call grecaptchaWaitingDownload`);
        if (!this._isReady && !this._isWaiting) {
            this.downloadGoogleAPI();
        }
        return this.subscription.asObservable();
    }
    /**
     * Metodo lanciato solo alla prima richiesta di creazione, effettua il download dell'api di Google
     * Setta lo stato di READY e WAITING
     * Avvisa tutti i sottoscrittori
     */
    downloadGoogleAPI() {
        this._isWaiting = true;
        if (typeof document === "object") {
            this.tpdLoggerService.printLog(this.ID_LOGGER, `call downloadGoogleAPI`);
            const script = document.createElement("script");
            script.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=explicit");
            script.setAttribute("async", "true");
            script.setAttribute("defer", "true");
            script.addEventListener("load", (evt) => {
                grecaptcha.ready(() => {
                    this._isReady = true;
                    this._isWaiting = false;
                    this.tpdLoggerService.printLog(this.ID_LOGGER, `grecaptcha isReady`);
                    this.subscription.next(true);
                });
            });
            document.body.appendChild(script);
        }
    }
}
exports.TpdGrecaptchaDownloadService = TpdGrecaptchaDownloadService;
